export class ValorCampoSerie {


  constructor(private NOMBRE_CAMPO: string, private VALOR: string, private ID?: number) { }

}
